import type { Locale } from "../schema/Locale.js";

const formatCache: Partial<Record<`${Locale}-${boolean}`, Intl.NumberFormat>> = {};
function createFormat(locale: Locale, withFraction: boolean): Intl.NumberFormat {
	const cached = formatCache[`${locale}-${withFraction}`];
	if (cached) {
		return cached;
	}

	const format = new Intl.NumberFormat(locale, {
		style: "currency",
		currency: "CZK",
		minimumFractionDigits: withFraction ? 2 : 0,
		maximumFractionDigits: 2,
	});
	formatCache[`${locale}-${withFraction}`] = format;
	return format;
}

export function formatPrice(number: number | string, locale: Locale, withFraction: boolean): string {
	return createFormat(locale, withFraction).format(typeof number === "string" ? parseFloat(number) : number);
}
